
export let socketUrl= "https://meetverse-mini.onrender.com" 
//"https://meetversemini.up.railway.app" //"https://calm-reef-30045.herokuapp.com"

